import Vue from "vue";
import { isEmpty, ValidationService } from "@fkui/logic";
import { MatrixServiceId, MatrixServiceImpl } from "@/services";
import { getNewState } from "@/store";

export const showComponentMixin = {
    methods: {
        shouldShowComponent(this: Vue, component: MatrixServiceId): boolean {
            return MatrixServiceImpl.isEnabled(component, this.$store.state);
        },
        isPopulated(text: string): boolean {
            return !isEmpty(text);
        },
    },
    data: () => ({
        MatrixServiceId,
    }),
};

export const onPopStateMixin = {
    created(this: Vue) {
        const { $store, $router, $t } = this;
        window.onpopstate = () => {
            const confirm = window.confirm(
                $t("SBRV.modal.text.avbrytuppgifterforsvinner"),
            );
            if (confirm) {
                $store.replaceState(getNewState());
                ValidationService.clearAllStates();
            } else {
                $router.push("anmalan");
            }
        };
    },
};

export const validationMixin = {
    computed: {
        $maxLengthTextField(): number {
            return 300;
        },
        $maxLengthTextArea(): number {
            return 2000;
        },
        $softLimit(): number {
            return 200;
        },
        $charactersLeft(this: Vue): string {
            return this.$t("SBRV.RW.etikett.antalteckenkvar.variabel");
        },
    },
};
